import { getApi, putApi } from './common/apis';

export default class PlatformSettingsService {
    /**
     * Get all platform settings. Site-admin only.
     * Returns { success, settings: [{ setting_key, setting_value, description, updated_by, updated_at }] }.
     */
    async getPlatformSettings() {
        return await getApi('v1/platform-settings');
    }

    /**
     * Update a single platform setting. Site-admin only.
     * Server allowlists the key and validates the value.
     */
    async updatePlatformSetting(settingKey, settingValue) {
        return await putApi('v1/platform-settings', {
            setting_key: settingKey,
            setting_value: settingValue,
        });
    }
}